import { Fab, Paper, Typography } from '@material-ui/core';
import { FieldArray } from 'react-final-form-arrays';
import AttendeeDetails from './AttendeeDetails';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';

const Attendees = ({push}) => (
  <Paper style={{ padding: 16, marginTop: 16 }}>
    <Typography variant="h6">Attendees</Typography>
    <FieldArray name="Attendees">
      {({ fields }) => fields.map((name, index) =>
        <AttendeeDetails
          style={{padding: 10}}
          key={name}
          name={name}
          index={index}
          total={fields.length}
          onDelete={() => fields.remove(index)}
        />
      )}
    </FieldArray>
    <Fab
      size="medium"
      color="secondary"
      aria-label="Add"
      style={{marginLeft: '98%', marginTop: 16}}
      onClick={() => push('Attendees', undefined)}
    >
      <AddIcon />
    </Fab>
  </Paper>
);

export default Attendees;
